import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, URL_API } from "../../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Input,
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import styles from "./styles.css";

function UserOption() {
  const loaderCss = css`
    margin: auto;
  `;

  const history = useHistory();
  const [enquiry, setEnquiry] = useState([]);
  const [loading, setloading] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showMultipleDelete, setShowMultipleDelete] = useState(false);
  const handleCloseMultipleDelete = () => setShowMultipleDelete(false);
  const handleShowMultipleDelete = () => setShowMultipleDelete(true);
  const [loader, showLoader] = useState(false)
  const [showModal, setShowLoader] = useState(false)
  const handleCloseLoader = () => setShowLoader(false)
  const [filterTitle, setFilterTitle] = useState()
  const [searchStatus, setSearchStatus] = useState(false)
  const [date, setDate] = useState(null)
  const [date2, setDate2] = useState(null)
  const [destroyEnquiryId, setDestroyEnquiryId] = useState(null)
  const [isChecked, setIsChecked] = useState('')

  useEffect(() => {
    getEnquiry();
  }, []);

  async function getEnquiry() {
    setloading(true)
    try {
      await axios.get(URL_API + "auth/admin/get-user-options").then((response) => {
        console.log('hel', response?.data?.status)
        if (response?.data?.status == 200) {
          console.log('hrere', response?.data?.userOption?.allow_delete)
          setIsChecked(response?.data?.userOption?.allow_delete)
        }
      });
    }
    catch (error) {
      console.error('error', error)

    }

  };


  const destroyEnquiryModal = (id) => {
    handleShow()
    setShowLoader(true)
    setDestroyEnquiryId(id)
  }

  const destroyEnquiry = (id) => {
    axios
      .post(URL_API + `auth/admin/car-enquiry-delete/${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          history.push("/admin/enquiry");
          toast.success("Enquiry Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setShowLoader(false)
          getEnquiry();
        }
      });
  };



  const clearFilter = () => {
    getEnquiry()
    let dateField = document.getElementById('title')
    dateField.value = ''
    setFilterTitle('')
    let dateField2 = document.getElementById('date-filter-id')
    dateField2.value = ''
    setDate(null)
    let dateField3 = document.getElementById('date2-filter-id')
    dateField3.value = ''
    setDate2(null)
  }

  const onSubmit = () => {
    setSearchStatus(true)
    let formData = new FormData()
    formData.append('allow_delete', isChecked)
    axios
      .post(URL_API + `auth/admin/update-user-option/${1}`, formData)
      .then((response) => {
        if (response?.data?.status == 200) {
          getEnquiry()
          toast('Records Updated Successfully', {
            showProgressBar: true,
            autoClose: 3000,
            type: 'success',
            position: 'top-right',
          })
        }
      })
      .catch((error) => {
        console.log(error?.response?.data?.errors)
      })
  }

  const hanldeCheckBox = (e) => {
    const { value, checked } = e.target
    if (checked) {
      setIsChecked([...isChecked, value])
    } else {
      setIsChecked(isChecked?.filter((e) => e !== value))
    }
  }

  const deleteRecords = async () => {
    setShowMultipleDelete(true)
  }

  const destroyMultipleEnquiries = (destroyMultipleEnquiries) => {
    let formData = new FormData()

    if (isChecked?.length > 0) {
      formData.append('enquiries', isChecked)
    } else {
      setShowMultipleDelete(false)
    }
    axios
      .post(URL_API + 'deleteMultitpleEnquiries', formData)
      .then((response) => {
        if (response?.data?.status == 200) {
          setShowMultipleDelete(false)
          setIsChecked([])
          getEnquiry()
          toast('Records Deleted Successfully', {
            showProgressBar: true,
            autoClose: 3000,
            type: 'success',
            position: 'top-right',
          })
        }
      })
      .catch((error) => {
        console.log(error?.response?.data?.errors)
      })
  }
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm()


  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">User Options</CardTitle>
              </CardHeader>
              <form onSubmit={onSubmit}>
                <div className="amenities-wrap start">
                  <div className="col-lg-12 mb-20">
                    <div className="feature-info">
                      <ul>
                        <li>
                          <div className={`form ${styles?.blogPostForm}`}>

                            <div className="form-group">
                              <label
                                className="form-check-label"
                                htmlFor="allow_delete"
                              >
                                Allow User To Delete Classified
                              </label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <select
                                className="form-check-input not-changed"
                                // {...register('allow_delete', {
                                //   required: false,
                                // })}
                                id="allow_delete"
                                name="allow_delete"
                                value={isChecked}
                                onChange={(e) => setIsChecked(e?.target?.value)}

                              // checked={isChecked}
                              >
                                <option value={''}>--select option--</option>
                                <option value={'Yes'}>Yes</option>
                                <option value={'No'}>No</option>
                              </select>

                            </div>

                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="tp-login-btn pt-10 pb-5">
                  <button className="btn btn-submit" type="submit">
                    Submit
                    <i>
                    </i>
                  </button>
                </div>
              </form>
            </Card>
          </Col>
        </Row >
      </div >


      <Modal
        show={showModal}
        onHide={handleCloseLoader}
        style={{
          marginTop: '150px',
          marginBottom: '100px',
          marginLeft: '480px',
          height: '900px',
          width: '900px',
          backgroundColor: 'transparent !important',
          top: 0,
          left: 0,
          border: 'none',
        }}
      >
        <>
          <div class="modalDialog modalConfirm">
            <div class="modalContent modal-content">
              <div class="modalHeader flex-column">
                <div class="iconBox">
                  {/* <i class="material-icons">&#xE5CD;</i> */}
                  <i className="fa fa-check"></i>
                </div>
                <h4 class="modalTitle w-100">Are you sure?</h4>
                {/* <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  &times;
                </button> */}
              </div>
              <div class="modalBody">
                <p>You want to Delete This Permanently?</p>
              </div>
              <div class="modalFooter justify-content-center">
                <button
                  type="button"
                  class="btn btnSecondary"
                  data-dismiss="modal"
                  onClick={() => destroyEnquiry(destroyEnquiryId)}
                >
                  Yes
                </button>
                <button
                  type="button"
                  class="btn btnDanger"
                  onClick={() => setShowLoader(false)}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </>
      </Modal>


      <Modal
        show={showMultipleDelete}
        onHide={handleCloseMultipleDelete}
        style={{
          marginTop: '150px',
          marginBottom: '100px',
          marginLeft: '480px',
          height: '900px',
          width: '900px',
          backgroundColor: 'transparent !important',
          top: 0,
          left: 0,
          border: 'none',
        }}
      >
        <>
          <div class="modalDialog modalConfirm">
            <div class="modalContent modal-content">
              <div class="modalHeader flex-column">
                <div class="iconBox">
                  {/* <i class="material-icons">&#xE5CD;</i> */}
                  <i className="fa fa-check"></i>
                </div>
                <h4 class="modalTitle w-100">Are you sure?</h4>
                {/* <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  &times;
                </button> */}
              </div>
              <div class="modalBody">
                <p>You want to Delete Theses Records Permanently?</p>
              </div>
              <div class="modalFooter justify-content-center">
                <button
                  type="button"
                  class="btn btnSecondary"
                  data-dismiss="modal"
                  onClick={() => destroyMultipleEnquiries(isChecked)}
                >
                  Yes
                </button>
                <button
                  type="button"
                  class="btn btnDanger"
                  onClick={() => setShowMultipleDelete(false)}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </>
      </Modal>
    </>
  );
}

export default UserOption;
